import { render, staticRenderFns } from "./ListHeading.vue?vue&type=template&id=b1a198ca&scoped=true&"
import script from "./ListHeading.vue?vue&type=script&lang=js&"
export * from "./ListHeading.vue?vue&type=script&lang=js&"
import style0 from "./ListHeading.vue?vue&type=style&index=0&id=b1a198ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a198ca",
  null
  
)

export default component.exports